import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiSuffixSelectModule } from '../lib/shared-ui-suffix-select.module'
import { SuffixSelectDocsComponent } from './suffix-select-docs/suffix-select-docs.component'
import { SuffixSelectExampleComponent } from './suffix-select-docs/suffix-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiSuffixSelectModule
  ],
  declarations: [
    SuffixSelectDocsComponent,
    SuffixSelectExampleComponent
  ],
  exports: [
    SuffixSelectDocsComponent
  ],
})
export class SharedUiSuffixSelectDocsModule {}
